export default __webpack_public_path__ + "kalish.1457ff4214aa0ad624c2.png";